import {
  createTranslator,
} from '@dataforsyningen/saul'

export function useFormatPrice(
  price: number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
) {
  return new Intl.NumberFormat('da-DK', {
    style: 'currency',
    currency: 'DKK',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(price)
}

export function useFormatNumber(
  price: number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
) {
  return new Intl.NumberFormat('da-DK', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(price)
}

export function mapHeatingSourceToLabel(
  heatingSource:
    | 'GAS'
    | 'OLIE'
    | 'EL'
    | 'EL_JORDVARME'
    | 'EL_VARMEPUMPE'
    | 'FJERNVARME'
    | 'HALM'
    | 'PILLER'
    | null,
) {
  switch (heatingSource) {
    case 'GAS':
      return 'Gas'
    case 'OLIE':
      return 'Olie'
    case 'EL':
      return 'El'
    case 'EL_JORDVARME':
      return 'Jordvarme'
    case 'EL_VARMEPUMPE':
      return 'Varmepumpe'
    case 'FJERNVARME':
      return 'Fjernvarme'
    case 'HALM':
      return 'Halm'
    case 'PILLER':
      return 'Piller'
    default:
      return heatingSource
  }
}

export function urlEncode(str: string) {
  // Replace '+' with space
  const replacedString = str.replace(/\+/g, ' ')

  // Encode the string
  return encodeURIComponent(replacedString)
}

/**
 * Retry utility with exponential backoff
 * @param fn - The async function to retry
 * @param options - Retry configuration
 * @returns Promise that resolves with the function result or rejects after all retries
 */
export async function retry<T>(
  fn: () => Promise<T>,
  options = { retries: 3, delay: 200, backoff: 2 },
): Promise<T> {
  const { retries, delay, backoff } = options

  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await fn()
    }
    catch (error) {
      const isLastAttempt = attempt === retries
      if (isLastAttempt) {
        throw error
      }

      const waitTime = delay * (backoff ** attempt)
      await new Promise(resolve => setTimeout(resolve, waitTime))
    }
  }

  throw new Error('Retry failed')
}

export function createBboxTranslator(fromProjection: string) {
  const translator = createTranslator(fromProjection)

  return (bbox: number[]) => {
    return [
      ...translator.forward([bbox[0], bbox[1]]),
      ...translator.forward([bbox[2], bbox[3]]),
    ]
  }
}

/**
 * Cloudinary-provideren henter billedet via en absolut URL. Lokale filer under
 * public/ kan den ikke nå, så de skal bruge Nuxts indbyggede provider.
 */
export function imageProvider(src?: string | null) {
  return src?.startsWith('http') ? 'cloudinary' : undefined
}
